import { FaRegUser } from 'react-icons/fa'
// import { personalMyCollectionNavigationConfig } from '../MyCollection/configs/navigation'
import { personalMyResultsNavigationConfig } from '../MyResult/configs/navigation'
import { personalDashboardNavigationConfig } from '../Dashboard/configs/navigation'
import { Explore, MilitaryTech, Star, StarRate } from '@mui/icons-material'
import { getAuthDataSession } from '@Core/Helpers/Session'
// import { personalExamExerciseResultConfig } from '../ResultExamExercise/configs/router'
// import { ROUTER_MY_ACCOUNT } from '../../MyAccount/configs/const'
// import { AccountBalance, AccountBox } from '@mui/icons-material'

const PersonalNavigationConfig = {
	id: 'personal',
	title: 'Cá nhân',
	type: 'collapse',
	icon: <FaRegUser />,
	checkHidden: () => {
		const type = getAuthDataSession('onboarding_data.type')
		const is_allow_lms = getAuthDataSession('onboarding_data.is_allow_lms')
		// console.log('type',type);
		if (is_allow_lms) {
			return true
		}
		if (type === 'TEACHER') {
			return true
		}
		return false
	},
	children: [
		{
			id: 'explore',
			title: 'Khám phá đề thi',
			type: 'item',
			icon: <Explore />,
			link: '/quiz/exam/explore'
		},
		...personalDashboardNavigationConfig,
		// ...personalMyCollectionNavigationConfig,
		...personalMyResultsNavigationConfig,
		// {
		// 	id: 'profile',
		// 	title: 'Thông tin tài khoản',
		// 	type: 'item',
		// 	icon: <AccountBox />,
		// 	link: ROUTER_MY_ACCOUNT.profile
		// }

		{
			id: 'ranking',
			title: 'BXH thi đua',
			type: 'item',
			icon: <MilitaryTech />,
			link: '/quiz/exam/ranking',
			suffix: '🔥' // <img width={20} src="/assets/images/rank/ranking.png" alt="ranking" /> //
		}
	]
}

export default PersonalNavigationConfig
